import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5ffffb6f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5ffffb6f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffffb6f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ffffb6f')) {
      api.createRecord('5ffffb6f', component.options)
    } else {
      api.reload('5ffffb6f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5ffffb6f&scoped=true", function () {
      api.rerender('5ffffb6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/generalForm/index.vue"
export default component.exports